import type {
  FullLanguageCode,
  InternationalLocalization,
  LanguageCode,
  LocalizationFamily,
} from '../models/language-code.model'
import {
  isInternationalLocalization,
  isInternationalLocalizationFamily,
} from '../models/language-code.model'

export const getMostRelevantLanguageCode = (basis: LanguageCode, available: LanguageCode[]): LanguageCode => {
  const family = (langCode: LanguageCode): string => langCode.slice(0, 2)

  const same = (): LanguageCode | undefined => available.find((l) => l === basis)
  const sameFamily = (): LanguageCode | undefined => available.filter((l) => family(l) === family(basis)).sort()[0]
  const englishFamily = (): LanguageCode | undefined => available.filter((l) => family(l) === 'en').sort()[0]
  const firstAlphabetical = (): LanguageCode => available.sort()[0]

  return same() ?? sameFamily() ?? englishFamily() ?? firstAlphabetical()
}

export const tryRemoveInternationalization = (languageCode: FullLanguageCode): LanguageCode => {
  if (isInternationalLocalization(languageCode)) {
    return languageCode.substring(0, languageCode.length - 4) as LanguageCode
  }

  return languageCode
}

export const tryAddInternationalization = (languageCode: LanguageCode): FullLanguageCode => {
  if (isInternationalLocalizationFamily(languageCode)) {
    return `${languageCode}-INT` as InternationalLocalization
  }

  return languageCode
}

export const transformLanguageCodeToLocalizationFamily = (langCode: LanguageCode): LocalizationFamily => {
  return langCode.substring(0, 2) as LocalizationFamily
}
